import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getSettings } from "@/lib/api";
import { Seo } from "@/components/site/Seo";
import { PageIntro } from "@/components/site/PageIntro";

export default function Policy({ kind = "privacy" }) {
  const { data: settings } = useQuery({ queryKey: ["settings"], queryFn: getSettings });
  const isPrivacy = kind === "privacy";
  const title = isPrivacy ? "Privacy Policy" : "Terms of Use";
  const custom = settings?.policies?.[isPrivacy ? "privacy" : "terms"];
  return (
    <>
      <Seo title={title} path={isPrivacy ? "/privacy" : "/terms"} settings={settings} />
      <PageIntro eyebrow="Policies" title={title} />
      <section className="container-inst py-16 lg:py-24">
        <div className="max-w-[70ch] space-y-4 text-sm leading-relaxed md:text-base" style={{ color: "var(--muted)" }}>
          {custom ? (
            custom.split("\n").filter(Boolean).map((p, i) => <p key={i}>{p}</p>)
          ) : (
            <>
              <p>Acharya Holdings respects the privacy and trust of everyone who engages with us. This policy describes, in general terms, how information shared with us is handled with care, confidentiality, and in accordance with applicable law.</p>
              <p>We collect only the information necessary to respond to enquiries and to operate our business responsibly. We do not sell personal information. Enquiries submitted through this website are used solely to respond to your request.</p>
              <p>For any questions regarding this policy or the information you have shared with us, please contact us using the details provided on our Contact page.</p>
            </>
          )}
        </div>
      </section>
    </>
  );
}
